/* 
•	scope: tipologia di operazione (login su web, operazione X ecc…)
•	appData: dato recuperato da Nexi per validare l’operazione
•	idOperation: ID operazione
•	user:  codice cliente (? Da validare)
•	otpExpirationInSeconds: durata validità OTP generato
•	qrCodeExpirationTimestamp: UTC timestamp since epoch (in millisecondi) di validità del QR code (opzionale)
 */
export type QrCodeValueType = {
  scope: string;
  appData: string;
  idOperation: string;
  clientCode: string;
  contractCode: string;
  otpExpirationInSeconds: number;
  qrCodeExpirationTimestamp?: number;
};

export enum LoginScreen {
  DEFAULT = "Login",
  PHYS_TOKEN = "Token",
  BLOCKED_USER = "blockedUser",
  SOFT_BLOCKED_USER = "softBlockedUser",
  FAILURE = "Failure",
  APP_NOTIFICATION = "Notification",
  SUCCESS = "Success",
  APP_QRCODE = "QRCode",
}

export const QR_CODE_SCOPE = "LOGIN";

export const OTP_EXPIRATION_IN_SECONDS = 30;
// The QR transaction is valid for 5 minutes.
export const QR_CODE_EXPIRATION_TIMESTAMP = 5;
